import clsx from 'clsx';
import styles from './DialogButtonFooter.module.scss';
import React from 'react';
export function DialogButtonFooter({ className, children }) {
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.buttonFooter, className)
    }, children);
}
